/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import EditRules from './EditRules/index'
import EditSteps from './EditSteps/index'
import Overview from './Overview/index'
import PreviewDefaultPaymentPlans from './PreviewDefaultPaymentPlans/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Overview'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Overview'}>
<Overview
  viewPath={`${viewPath}/Overview`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'EditSteps'}>
<EditSteps
  viewPath={`${viewPath}/EditSteps`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'EditRules'}>
<EditRules
  viewPath={`${viewPath}/EditRules`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PreviewDefaultPaymentPlans'}>
<PreviewDefaultPaymentPlans
  viewPath={`${viewPath}/PreviewDefaultPaymentPlans`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}